export class ConstConfig {
  public static DefaultRoute = '/wallet';
}
